import SeasonalCard from '@/components/game/ui/card/SeasonalCard';

const CardPile = ({ title, cards }) => {
	if (cards.length <= 0) return;

	function cardGenerator(cardId) {
		return (
			<div className="card" key={cardId}>
				<SeasonalCard cardId={cardId} width={0} height={0} />
			</div>
		);
	}

	return (
		<div>
			<h2>{title}</h2>
			<div className="hand">
				{cards.map((cardId) => cardGenerator(cardId))}
			</div>
		</div>
	);
};

export default CardPile;
